import { get, remove, set } from "hassibot/local-storage";
import { FeatureFlags } from "hassibot/util/roles";

const COORDINATED_UPDATE_KEY = "HB_COORDINATED_UPDATE_ENABLED";
const LEGACY_DEPLOYMENT_OPT_IN_KEY = "HB_DEPLOYMENT_OPT_IN";

let snapshot = get(COORDINATED_UPDATE_KEY) === "true";
let isSynchronized = false;
const listeners = new Set<() => void>();

const syncCanaryStateFromStorage = (nextIsSynchronized = isSynchronized): void => {
  const nextSnapshot = get(COORDINATED_UPDATE_KEY) === "true";
  if (snapshot === nextSnapshot && isSynchronized === nextIsSynchronized) return;
  snapshot = nextSnapshot;
  isSynchronized = nextIsSynchronized;
  listeners.forEach(listener => listener());
};

/** Store the backend-controlled canary state for synchronous, cross-tab reads. */
export const syncCoordinatedUpdateCanary = (featureFlags: readonly string[]): void => {
  remove(LEGACY_DEPLOYMENT_OPT_IN_KEY);
  set(
    COORDINATED_UPDATE_KEY,
    featureFlags.includes(FeatureFlags.HASSIBOT_ALL_TABS_UPDATE) ? "true" : "false"
  );
  syncCanaryStateFromStorage(true);
};

export const isCoordinatedUpdateEnabled = (): boolean => get(COORDINATED_UPDATE_KEY) === "true";
export const isCoordinatedUpdateCanarySynchronized = (): boolean => isSynchronized;

export const coordinatedUpdateCanaryStore = {
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  getSnapshot(): boolean {
    return snapshot;
  },
};

if (typeof window !== "undefined") {
  window.addEventListener("storage", event => {
    if (event.key === COORDINATED_UPDATE_KEY) syncCanaryStateFromStorage(true);
    if (event.key === null) syncCanaryStateFromStorage(false);
  });
}
